export const postNavBar = [
  {
    text: "Content Managment",
    icon: "mdi-book-open-page-variant",
    items: [],
  },
];
